export default "__VITE_ASSET__BmfWcGfR__"